import { Link } from '@tanstack/react-router';
import { BrandLockup } from './BrandLockup.js';

export function Footer() {
  return (
    <footer className="bg-brand-ink text-brand-cream">
      <div className="mx-auto max-w-6xl px-6 py-14 sm:px-12">
        <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <BrandLockup tone="dark" />
            <p className="mt-4 max-w-sm text-sm text-brand-cream/70">
              Bookings that only offer what your team can actually do. Made in
              Australia.
            </p>
          </div>

          <FooterColumn title="Industries">
            <FooterLink to="/industries">All industries &rarr;</FooterLink>
            <FooterLink to="/for-medical-imaging">Medical imaging</FooterLink>
            <FooterLink to="/for-allied-health">Clinics &amp; allied health</FooterLink>
            <FooterLink to="/for-trades">Mobile trades</FooterLink>
            <FooterLink to="/for-gardening">Gardening</FooterLink>
          </FooterColumn>

          <FooterColumn title="Product">
            <FooterLink to="/features">Features</FooterLink>
            <FooterLink to="/pricing">Pricing</FooterLink>
            <FooterLink to="/about">About</FooterLink>
            <FooterLink to="/contact">Contact</FooterLink>
            <FooterLink to="/technology">Technology stack</FooterLink>
          </FooterColumn>

          <FooterColumn title="Company">
            <FooterLink to="/legal">Legal</FooterLink>
            <FooterLink to="/contact">Get in touch</FooterLink>
          </FooterColumn>
        </div>

        <div className="mt-12 flex flex-col gap-2 border-t border-brand-cream/10 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-brand-cream/50">
            © {new Date().getFullYear()} Bookaburra. Made in Australia.
          </p>
        </div>
      </div>
    </footer>
  );
}

function FooterColumn({
  title,
  children,
}: {
  title: string;
  children: React.ReactNode;
}) {
  return (
    <div>
      <h3 className="text-xs font-semibold uppercase tracking-widest text-brand-cream/50">
        {title}
      </h3>
      <ul className="mt-4 space-y-2">{children}</ul>
    </div>
  );
}

function FooterLink({
  to,
  children,
}: {
  to: string;
  children: React.ReactNode;
}) {
  return (
    <li>
      <Link
        to={to}
        className="text-sm text-brand-cream/70 hover:text-brand-cream"
      >
        {children}
      </Link>
    </li>
  );
}
